import {
  ResourceStatus,
  ResourceStatusResponse,
  ResourceStatusStatus,
} from '@thiememeulenhoff/types/src';

const actionForStatus = (status: ResourceStatusStatus) =>
  status === 'disabled' || status === 'enabled' || status === 'indeterminate'
    ? 'disable'
    : 'check';

export const buildResourceStatusIdentifier = (
  actorId: string,
  contentPath: string,
  status: ResourceStatusStatus,
): string => `${actorId}-${contentPath}=${actionForStatus(status)}`;

const convertToResourceStatus = (
  response: ResourceStatusResponse,
  contentPath: string,
): ResourceStatus => ({
  identifier: buildResourceStatusIdentifier(
    response.actor,
    contentPath,
    response.status,
  ),
  actor: response.actor,
  contentPath,
  status: response.status,
  action: actionForStatus(response.status),
});

export const convertToResourceStatuses = (
  states: Array<ResourceStatusResponse>,
) => {
  return states.reduce(
    (entities: Array<ResourceStatus>, value: ResourceStatusResponse) => {
      value.contentPaths.forEach((contentPath: string) =>
        entities.push(convertToResourceStatus(value, contentPath)),
      );

      return entities;
    },
    [],
  );
};
